import { createI18n } from 'vue-i18n'
import it from './it'

// modalità legacy: true per ridurre il diff iniziale (API $t identica a vue-i18n 8)
const i18n = createI18n({
  legacy: true,
  locale: 'it',
  fallbackLocale: 'it',
  messages: { it },
})

export default i18n
